export const toBase64 = (data: string): string =>
  btoa(String.fromCodePoint(...new TextEncoder().encode(data)));

export const fromBase64 = (data: string): string =>
  new TextDecoder().decode(Uint8Array.from(atob(data), (c) => c.charCodeAt(0)));
